// eslint-disable-next-line no-shadow
export enum methodTypeEnum {
  static = 'Static',
  singleton = 'Singleton'
}
